import { KpiMetricCard } from '@/components/shared/KpiMetricCard'
import type { StoryAnalyticsTotals } from '@/types/story'

export interface AnalyticsKpiRailProps {
  totals: StoryAnalyticsTotals
}

function roundPct(n: number): number {
  return Math.round(n * 10) / 10
}

/**
 * Three-card KPI rail sitting above the SP4 story-first Analytics page
 * (spec §4.3). Cards: Total stories / % Established / Avg cluster size.
 * Deltas are signed against the `priorPeriod` totals.
 *
 * % Single-source was removed from this rail (KAN-231) — its canonical
 * signal lives in the separate SingleSourceRail component on the same page.
 */
export function AnalyticsKpiRail({ totals }: AnalyticsKpiRailProps) {
  const deltaTotal = totals.total - totals.priorPeriod.total
  const deltaEstablished = roundPct(
    totals.pctEstablished - totals.priorPeriod.pctEstablished,
  )
  const deltaCluster = roundPct(
    totals.avgClusterSize - totals.priorPeriod.avgClusterSize,
  )

  return (
    <div
      data-testid="sp4-kpi-rail"
      className="grid grid-cols-2 gap-3 sm:grid-cols-3"
    >
      <KpiMetricCard
        label="Total stories"
        value={totals.total}
        delta={deltaTotal}
        deltaSuffix=""
      />
      <KpiMetricCard
        label="% Established"
        value={`${roundPct(totals.pctEstablished)}%`}
        delta={deltaEstablished}
        deltaSuffix="pp"
      />
      <KpiMetricCard
        label="Avg cluster size"
        value={roundPct(totals.avgClusterSize)}
        delta={deltaCluster}
        deltaSuffix=""
      />
    </div>
  )
}
